export type EntrataClientProduct = 'invoice_processing' | 'eli_invoice_entry'

export const ENTRATA_CLIENT_PRODUCT_LABELS: Record<
  EntrataClientProduct,
  string
> = {
  invoice_processing: 'Invoice Processing',
  eli_invoice_entry: 'ELI',
}

export type CreateEntrataClientRequest = {
  cid: string
  name: string
  subdomain: string
  product: EntrataClientProduct
}

export type CreateEntrataClientResponse = {
  client_org_id: string
  client_created: boolean
  property_orgs_created: number
  data_list_sync_queued: boolean
}
